import type { ReactNode } from "react";
import { V2_ACCENT } from "./classes";

/** The gradient-filled word(s) of a V2 headline. Place it inside the page's single h1. */
export function V2Accent({ children }: { children: ReactNode }) {
  return <span className={V2_ACCENT}>{children}</span>;
}
